module.exports = __webpack_public_path__ + "static/media/cancel.a4ad2f5e.svg";